__turbopack_context__.v({
  "className": "geist_mono_94686b31-module__KnXEdG__className",
  "variable": "geist_mono_94686b31-module__KnXEdG__variable",
});
